import React from 'react';

export default function AccountCardSkeleton() {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 animate-pulse">
      <div className="flex justify-between items-start mb-4">
        <div className="flex-1">
          <div className="h-4 bg-gray-200 rounded w-24 mb-2" />
          <div className="h-3 bg-gray-100 rounded w-32" />
        </div>
        <div className="flex items-center gap-3">
          <div className="h-8 w-8 bg-gray-200 rounded" />
          <div className="h-8 w-8 bg-gray-200 rounded" />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <div className="h-3 bg-gray-100 rounded w-20 mb-1" />
          <div className="h-4 bg-gray-200 rounded w-24" />
        </div>
        <div>
          <div className="h-3 bg-gray-100 rounded w-20 mb-1" />
          <div className="h-4 bg-gray-200 rounded w-24" />
        </div>
        <div>
          <div className="h-3 bg-gray-100 rounded w-20 mb-1" />
          <div className="h-4 bg-gray-200 rounded w-24" />
        </div>
        <div>
          <div className="h-3 bg-gray-100 rounded w-20 mb-1" />
          <div className="h-4 bg-gray-200 rounded w-24" />
        </div>
      </div>
    </div>
  );
}

